export default __webpack_public_path__ + "img/fqjdMlHF.aedc5f33.svg";